"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("./styles/styles");
var CardTimeSeries_1 = require("./CardTimeSeries");
var formatting_1 = require("./formatting/formatting");
var LastUpdateLabel_1 = require("./LastUpdateLabel");
var MetricValueLabel_1 = require("./MetricValueLabel");
var widgets_1 = require("@tableau/widgets");
var MetricCardWithTimeSeries = /** @class */ (function (_super) {
    __extends(MetricCardWithTimeSeries, _super);
    function MetricCardWithTimeSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTimeSeries = function () {
            if (_this.props.timeSeries && _this.props.timeSeries.length > 0) {
                return (React.createElement(CardTimeSeries_1.CardTimeSeries, { timeSeriesHeight: _this.props.timeSeriesHeight, data: _this.props.timeSeries, testId: 'time-series' }));
            }
            else {
                return React.createElement("div", { style: { height: _this.props.timeSeriesHeight } });
            }
        };
        return _this;
    }
    MetricCardWithTimeSeries.prototype.render = function () {
        return (React.createElement("div", { "data-tb-test-id": this.props.testId, style: __assign({}, styles_1.canvasStyle, this.props.style, { width: this.props.width, height: this.props.height }) },
            React.createElement(LastUpdateLabel_1.LastUpdateLabel, { testId: this.props.testId + '-UpdateDate', style: { fontSize: widgets_1.TabStyles.Typography.Sizing.Default, paddingBottom: 10 }, lastUpdateDate: this.props.lastUpdatedTimestamp ? formatting_1.formatLastUpdatedDate(this.props.lastUpdatedTimestamp) : '' }),
            React.createElement("div", { style: {
                    flex: '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                } },
                React.createElement(MetricValueLabel_1.MetricValueLabel, { testId: this.props.testId + '-Value', style: this.props.valueStyle }, formatting_1.formatValueAsMetricNumber(this.props.initialValue))),
            this.renderTimeSeries()));
    };
    return MetricCardWithTimeSeries;
}(React.PureComponent));
exports.MetricCardWithTimeSeries = MetricCardWithTimeSeries;
//# sourceMappingURL=MetricCardWithTimeSeries.js.map